document.addEventListener('DOMContentLoaded', function() {
  // 説明文の「もっと見る」ボタンの機能を実装（.director-profile__content 内に限定）
  const descriptionToggles = document.querySelectorAll('.director-profile__content [data-description-toggle]');
  
  // 初期状態で5行制限を適用（JavaScriptの準備ができるまで） - .director-profile__content 内に限定
  const descriptionElements = document.querySelectorAll('.director-profile__content .collection-hero__description');
  descriptionElements.forEach(element => {
    const content = element.querySelector('[data-description-content]');
    if (content) {
      content.setAttribute('data-collapsed', 'true');
    }
  });
  
  descriptionToggles.forEach(toggle => {
    // ボタンの親要素（toggle-container）を取得
    const toggleContainer = toggle.closest('.collection-hero__description-toggle-container');
    // 説明文のコンテンツ要素を取得（toggle-containerの前の兄弟要素）
    const content = toggleContainer.previousElementSibling;
    
    // 初期状態を設定（5行制限を適用）
    content.setAttribute('data-collapsed', 'true');
    toggle.setAttribute('data-expanded', 'false');
    
    // テキストが5行以下の場合は「もっと見る」ボタンを非表示にする
    const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
    const maxHeight = lineHeight * 8;
    const actualHeight = content.scrollHeight;
    
    if (actualHeight <= maxHeight) {
      // テキストが5行以下の場合は「もっと見る」ボタンを非表示
      toggleContainer.style.display = 'none';
      // 5行制限も解除
      content.setAttribute('data-collapsed', 'false');
    } else {
      // ボタンクリック時の処理
      toggle.addEventListener('click', function() {
        // 説明文を展開
        content.setAttribute('data-collapsed', 'false');
        toggle.setAttribute('data-expanded', 'true');
      });
    }
  });
  
  // 処理完了後に「もっと見る」ボタンを表示（js-readyクラスを追加）
  descriptionElements.forEach(element => {
    element.classList.add('js-ready');
  });
});
